<template>
  <div>
    <div v-if="loadingShow"
         style="margin: 40vh auto 0;">
      <div class="el-icon-loading"
           style="font-size: 50px;"></div>
      <div style="font-size: 20px;">等待中</div>
    </div>
    <div v-if="errorShow"
         style="color: rgb(184, 71, 77);margin: 40vh auto 0;">
      <div class="el-icon-warning-outline"
           style="font-size: 50px;"></div>
      <div style="font-size: 20px;">认证失败</div>
    </div>
  </div>
</template>

<script>
import {
  mapMutations
} from "vuex";
export default {
  name: 'DeqingBridgeAndTunnelAvoidLogin',

  data () {
    return {
      errorShow: false,
      loadingShow: false,
    };
  },
  created () {
  },
  mounted () {
    let token = this.$route.query.token
    this.createdLogin(token)
    // this.createdLogin()
  },

  methods: {
    ...mapMutations(["SET_USER", "editUserInfo", "editMenus", 'editBackBut']),
    async createdLogin (token) {
      console.log(token);
      if (token) {
        this.loadingShow = true
        const res = await this.$api.sendGet("/accountInfo/avoidLogin", { token });
        if (res.errcode === 0) {

          this.loadingShow = false
          this.errorShow = false;
          sessionStorage.setItem('token', res.data.token);
          sessionStorage.setItem('userInfo', JSON.stringify(res.data));
          // console.log(res);
          this.SET_USER(res.data);
          this.editUserInfo(res.data);
          this.editBackBut(2)
          if (res.data.menus) {
            res.data.menus.map((item) => {
              item.icon = item.icon ?
                require(`@/assets/image/${item.icon}.png`) :
                "";
            });
          }
          this.editMenus(res.data.menus);
          this.$router.push("/layout");
        } else {
          this.loadingShow = false
          this.errorShow = true
        }
      } else {
        this.errorShow = true
      }
    }
  },
};
</script>

<style lang="scss" scoped>
</style>